import { useInView } from "react-intersection-observer";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
// import Head from "next/head";
import { useCallback, useEffect, useState } from "react";
import { getDataFromSSR } from "@/handlers/client/commonClient";
// import Head from "next/head";
import { useWindowSize } from "@/hooks/useIsMobile";
import GTMScript from "@/component/Ads/GTMScript";

const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const List1 = dynamic(() => import("@/component/Listing/VideoList1"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
const List2 = dynamic(() => import("@/component/Listing/VideoList2"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
// const Pagination = dynamic(() => import("@/component/Pagination"));
const NoData = dynamic(() => import("@/component/NoData"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
// const VDOAdsScript = dynamic(() => import("@/component/Ads/VDOAdsScript"));
// const VDOAdSlot = dynamic(() => import("@/component/Ads/VDOAdSlot"));

const Story = ({ storyPageData = null }) => {
  // console.log("Videopage data ",storyPageData)
  const [currentPage, setCurrentPage] = useState(0);
  const size = useWindowSize();
  const [videosData, setVideosData] = useState(
    // storyPageData?.content ? storyPageData?.content : []
    storyPageData?.content?.filter((item) => item.content_type != "video")
  );
  const [hasMore, setHasMore] = useState(true);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );

  const router = useRouter();
  const [insightref, insightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });
  const [mobileInsightref, mobInsightView] = useInView({
    threshold: 0,
    rootMargin: "40%",
  });

  // const handlePageClick = (page) => {
  //   if (currentPage === page) return;
  //   setCurrentPage(page);
  //   let currentPath = router?.asPath?.split("?")[0];
  //   window.location.href = `${currentPath}?page=${page}`;
  // };

  const getMorePost = async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    setLoadingSpinner(true);

    const fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getStories?page=${currentPage}`
    );

    const newContent = fetchedData?.data?.storyData?.content?.filter(
      (item) => item.content_type !== "video"
    ) || [];

    if (newContent.length > 0) {
      setVideosData((prevData) => [...prevData, ...newContent]);
    } else {
      setHasMore(false);
    }

    setLoadingSpinner(false);
  };

  const handleNavigation = useCallback(
    (e) => {
      if (y > window.scrollY) {
        setScrollDirection("Scrolling Up");
      } else if (y < window.scrollY) {
        setScrollDirection("Scrolling Down");
      }
      setY(window.scrollY);
    },
    [y]
  );
  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    function handleScroll() {
      if (!scrolled) {
        setScrolled(true);
      }
    }
    window.addEventListener("scroll", handleScroll);
    return () => { window.removeEventListener("scroll", handleScroll); };
  }, []);
  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {

          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());
          }

          if (scrolled) {
            if (videosData?.length > 7) {
              googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434604998-0"
                )
                .addService(googletag.pubads());
            }
            // }

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          {
            !scrolled && googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());
          }

          // // googletag.pubads().enableSingleRequest();
          googletag.enableServices();

          !scrolled && googletag.cmd.push(function () {
            var INTERSTITIALAd = googletag
              .defineOutOfPageSlot(
                "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                googletag.enums.OutOfPageFormat.INTERSTITIAL
              )
              .addService(googletag.pubads());

            googletag.display(INTERSTITIALAd);
          });
        });
      } else {
        googletag.cmd.push(function () {

          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1707804176041-1"
              )
              .addService(googletag.pubads());
          }
          if (scrolled) {
            {
              videosData &&
                videosData?.length > 7 &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                    [728, 90],
                    "div-gpt-ad-1707804176041-2"
                  )
                  .addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // // googletag.pubads().enableSingleRequest();
          googletag.enableServices();
        });
      }
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, [scrolled]);
  useEffect(() => {
    if (
      (insightView || mobInsightView) &&
      scrollDirection == "Scrolling Down" &&
      hasMore
    ) {
      setCurrentPage(currentPage + 1);
    }
  }, [insightView, mobInsightView, scrollDirection]);

  useEffect(() => {
    currentPage > 0 && !loadingSpinner && getMorePost();
    let height = window?.scrollY;
    window.scrollTo(0, height);
  }, [currentPage]);

  // console.log("VideoPage", latestVideoData);

  //META TAG DATA FOR STORY PAGE
  const metaTitle = "हिंदी न्यूज़ पढ़ें, Today’s Breaking News Story in Hindi और आज की Top News Headlines - NewsTak"

  const metaDesc = "Latest Hindi News (हिंदी न्यूज़): जानिए देश, विदेश, खेल, राजनीति, क्राइम, ऑटोमोबाइल, टेक्नोलॉजी, शिक्षा, लाइफस्टाइल, क्रिकेट, breaking news, और फ़िल्मों से जुड़ी सभी खबरें हिंदी में (News Stories In Hindi) NewsTak पर."

  const metaKeyword = " Hindi news Article, news story in hindi, breaking news article in hindi, latest news article in hindi, latest hindi news Stories, today news story in hindi, हिंदी न्यूज़, Breaking News in Hindi, फ़िल्मों की खबरें, खेल समाचार, राजनीति की खबरें, क्राइम न्यूज़, लाइफस्टाइल, क्रिकेट समाचार,"


  //   const metaTitle = "Watch Engaging Videos on News, Politics & More | Newstak";
  //   const metaDesc =
  //     "Discover a range of informative & entertaining videos on news, politics, current affairs, and beyond on Newstak. Stay updated and engaged with our diverse collection of latest video content.";
  //   const metaKeyword =
  //     "News Video, Hindi News Videos, न्यूज़ वीडियो, हिन्दी समाचार वीडियो, latest news video in hindi";

  return (
    <section>
      <HeadTag
        title={metaTitle}
        description={metaDesc}
        keywords={metaKeyword}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + "/stories"}
        image={`https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/brand-logo-1-ns.png`}
      lcpImage={storyPageData?.content?.[0]?.image}
      />
      <GTMScript />
      <WebpageSchema
        title={metaTitle}
        description={metaDesc}
        keywords={metaKeyword}
        canonicalUrl={process.env.NEXT_PUBLIC_WEBSITE_URL + "/stories"}
      />
      <BreadcrumbSchema
        breadcrumbList={[
          {
            // title: "वीडियो",
            title: "स्टोरीज़",
            canonical_url: "/stories",
          },
        ]}
      />
      <ItemsListSchema data={storyPageData?.content} />
      <Breadcrumb
        breadcrumbList={[
          {
            // title: "वीडियो",
            title: "स्टोरीज़",
            canonical_url: "/stories",
            icon: "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/read.svg",
          },
        ]}
      />
      {/* <VDOAdsScript /> */}

      <section className="mx-4 md:mx-4 md:px-2 py-2">
        <AdSlot728x90
          divId="div-gpt-ad-1659424515060-0"
          minWidth="720px"
          minHeight="90px"
        />

        {size.width < 900 ? (
          <div>
            <List1
              title="स्टोरीज़"
              newsListData={videosData}
              isLCP={true}
              showAds={true}
              haveH1={true}
              isTvAds={true}
              scrolled={scrolled}
            />
            <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={mobileInsightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div>
            <List2
              title="स्टोरीज़"
              newsListData={videosData}
              isLCP={true}
              haveH1={true}
              showAds={true}
              scrolled={scrolled}
            />
            <div
              className="h-[50px] w-full mb-4 text-sports news-load container-0"
              ref={insightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div>
          </div>
        )}
        {storyPageData?.content?.length === 0 && videosData?.length === 0 && (
          <NoData message="No Data Found" />
        )}

        {scrolled && <AdSlot300x250
          divId="div-gpt-ad-1659435474737-0"
          minWidth="300px"
          minHeight="250px"
        />}

        {scrolled && <AdSlot728x90
          divId="div-gpt-ad-1659425743360-0"
          minWidth="720px"
          minHeight="90px"
        />}

        {/* <Pagination
          handlePageClick={handlePageClick}
          currentPage={currentPage}
          totalPages={totalPages}
        /> */}
      </section>
    </section>
  );
};

export default Story;
